import { render, staticRenderFns } from "./LgsCenterCosteAre.vue?vue&type=template&id=1dbefdea&"
import script from "./LgsCenterCosteAre.vue?vue&type=script&lang=js&"
export * from "./LgsCenterCosteAre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports